import axios from 'axios';

export default axios.create({
    baseURL : "https://bling.porichorja.org"
    // baseURL: "https://localhost:7073"
})